var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22.001,
    viewBox: "0 0 22.001 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.15.9-5.367-4.318a.51.51,0,0,0-.365-.15H-6.3a8.913,8.913,0,0,0,2.174-5.844,8.936,8.936,0,0,0-8.937-8.937A8.936,8.936,0,0,0-22-10.312a8.936,8.936,0,0,0,8.938,8.938A8.913,8.913,0,0,0-7.219-3.549v.567a.528.528,0,0,0,.15.365L-1.852,2.6a.516.516,0,0,0,.73,0l.971-.971A.516.516,0,0,0-.15.9ZM-13.062-3.437a6.873,6.873,0,0,1-6.875-6.875,6.873,6.873,0,0,1,6.875-6.875,6.873,6.873,0,0,1,6.875,6.875A6.873,6.873,0,0,1-13.062-3.437Z",
    transform: "translate(22 19.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/icons_Search.8d1243a1ac7b8de7074dcc208ba7a9b2.svg";
export { ForwardRef as ReactComponent };